import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const [i, setI] = useState(false);
  const navigate = useNavigate();

  // const location = useLocation();
  // console.log(location);
  
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);

      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);
  useEffect(() => {
    var logOutFalse = localStorage.getItem('key');
    var userType = localStorage.getItem('usertype');
    if (logOutFalse == 'true') {
      if (userType === 'Member') {
        if(width <768){
          
          navigate('/pre-dash');
        }
        else{
          navigate('/member-dashboard');
        }
        
      } else {
        navigate('/admin-dashboard');
      }

      setI(true);
    } else {
      setI(false);
    }
  }, []);

  return <>{children}</>;
};

export default GuestGuard;
